import { render, staticRenderFns } from "./ConsumedTickets.vue?vue&type=template&id=0cd19722&"
import script from "./ConsumedTickets.vue?vue&type=script&lang=js&"
export * from "./ConsumedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports